/* Reviews carousel (per-edition on multi-variant products): follows ds:variant-change from ds-product.js. */
(() => {
  const root = document.querySelector('[data-ds-vr]');
  if (!root) return;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const items = Array.from(root.querySelectorAll('[data-ds-vr-item]'));
  const track = root.querySelector('[data-ds-vr-track]');
  const select = document.querySelector('[data-ds-variant-select]');
  const scopeBtns = root.querySelectorAll('[data-ds-vr-scope]');
  const note = root.querySelector('[data-ds-vr-note]');
  const prev = root.querySelector('[data-ds-vr-prev]');
  const next = root.querySelector('[data-ds-vr-next]');
  const progress = root.querySelector('[data-ds-vr-progress]');
  const total = { c: Number(root.dataset.c) || items.length, a: Number(root.dataset.a) || 0 };
  let scope = scopeBtns.length ? 'variant' : 'all';

  const variantId = () => (select ? select.value : '');
  const variantName = () => {
    const o = select && select.querySelector(`option[value="${variantId()}"]`);
    return o ? [o.dataset.o1, o.dataset.o2, o.dataset.o3].filter(Boolean).join(' / ') : '';
  };

  function updateNav() {
    if (!track) return;
    const max = track.scrollWidth - track.clientWidth;
    const x = Math.abs(track.scrollLeft);
    prev.disabled = x <= 2;
    next.disabled = x >= max - 2;
    root.classList.toggle('is-static', max <= 2);
    progress.style.width = max <= 2 ? '100%' : Math.max(12, (track.clientWidth + x) / track.scrollWidth * 100) + '%';
  }

  function markClamped() {
    root.querySelectorAll('[data-ds-vr-quote]').forEach(q => {
      const btn = q.nextElementSibling;
      if (!btn || q.classList.contains('is-open')) return;
      btn.hidden = q.scrollHeight <= q.clientHeight + 2;
    });
  }

  function setScore(avg, count, suffix) {
    root.querySelector('[data-ds-vr-avg]').textContent = avg.toFixed(1);
    const stars = root.querySelector('[data-ds-vr-stars]');
    stars.style.setProperty('--ds-vr-fill', (avg * 20) + '%');
    stars.setAttribute('aria-label', `Rated ${avg.toFixed(1)} out of 5`);
    root.querySelector('[data-ds-vr-based]').textContent = `Based on ${count} ${count === 1 ? 'review' : 'reviews'}${suffix}`;
  }

  function render() {
    if (!items.length) return;
    const vid = variantId();
    const mine = scopeBtns.length ? items.filter(li => li.dataset.v === vid) : [];
    if (scopeBtns.length) {
      root.querySelector('[data-ds-vr-n-variant]').textContent = mine.length;
      root.querySelector('[data-ds-vr-edition]').textContent = variantName();
    }
    const empty = scope === 'variant' && mine.length === 0;
    if (note) note.hidden = !empty;
    const showMine = scope === 'variant' && !empty;
    const list = showMine ? mine : items;
    items.forEach(li => { li.hidden = !list.includes(li); });

    if (showMine) setScore(mine.reduce((a, li) => a + Number(li.dataset.s), 0) / mine.length, mine.length, ' for this edition');
    else setScore(total.a, total.c, '');

    track.scrollLeft = 0;
    requestAnimationFrame(() => { markClamped(); updateNav(); });
  }

  if (track) {
    const step = () => {
      const card = items.find(li => !li.hidden);
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return card ? card.getBoundingClientRect().width + gap : track.clientWidth;
    };
    prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }));
    track.addEventListener('scroll', updateNav, { passive: true });
    track.addEventListener('keydown', e => {
      if (e.key === 'ArrowRight') { e.preventDefault(); next.click(); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); prev.click(); }
    });
    window.addEventListener('resize', () => { markClamped(); updateNav(); });
    root.addEventListener('click', e => {
      const btn = e.target.closest('[data-ds-vr-readmore]');
      if (!btn) return;
      const open = btn.previousElementSibling.classList.toggle('is-open');
      btn.textContent = open ? 'Show less' : 'Read more';
    });
    document.querySelectorAll('[data-ds-tab-trigger="reviews"], [data-ds-acc="reviews"]').forEach(b =>
      b.addEventListener('click', () => requestAnimationFrame(() => { markClamped(); updateNav(); })));
  }

  scopeBtns.forEach(btn => btn.addEventListener('click', () => {
    scope = btn.dataset.dsVrScope;
    scopeBtns.forEach(b => {
      b.classList.toggle('is-active', b === btn);
      b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
    });
    render();
  }));
  document.addEventListener('ds:variant-change', render);

  // Write a review → Judge.me's own form. Its widget sits right after this section so the form opens on white.
  const widget = document.getElementById('judgeme_product_reviews');
  if (widget) root.after(widget);
  root.querySelector('[data-ds-vr-write]').addEventListener('click', () => {
    if (!widget) return;
    const link = widget.querySelector('.jdgm-write-rev-link');
    const formEl = () => widget.querySelector('.jdgm-form-wrapper');
    const closed = () => !formEl() || getComputedStyle(formEl()).display === 'none';
    const canOpen = () => window.jdgm && typeof jdgm.openForm === 'function' && jdgm.$;
    const scrollToForm = () => setTimeout(() => (formEl() || widget).scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }), 450);
    if (!closed()) return scrollToForm();
    // Judge.me renders its form on the first link click (without opening it), then opens it with openForm
    if (!formEl() && link) link.click();
    let tries = 0;
    const open = () => {
      if (!closed()) return scrollToForm();
      if (formEl() && canOpen()) { jdgm.openForm(jdgm.$(widget)); return scrollToForm(); }
      if (++tries < 20) setTimeout(open, 100);
      else if (link) { link.click(); scrollToForm(); }
    };
    open();
  });

  // Rating badge near the title → open the Reviews tab / accordion and scroll to it
  const jump = document.querySelector('[data-ds-vr-jump]');
  if (jump) jump.addEventListener('click', e => {
    e.preventDefault();
    const tab = document.querySelector('[data-ds-tab-trigger="reviews"]');
    const acc = document.querySelector('[data-ds-acc="reviews"]');
    if (acc && getComputedStyle(acc).display !== 'none') { if (!acc.classList.contains('is-open')) acc.click(); }
    else if (tab) tab.click();
    root.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  });

  render();
})();
